export const pageCustomFieldsMap: any = {
  'inventories': 'stockItems',
  'receiveHistory': 'stockItems',
  'purchaseOrders': 'stockItems,vendors',
  "salesOrders": "stockItems,customers",
  "disposeHistory": "stockItems",
  "issueHistory": "stockItems,customers,salesOrders",
  "moveHistory": "stockItems",
  "returnHistory": "stockItems",
  "packHistory": "stockItems,customers,salesOrders",
  "adjustInventoryHistory": "stockItems",
  "history": "stockItems,customers,salesOrders,vendors,purchaseOrders",
  "shipHistory": "stockItems,customers,salesOrders",
  "salesOrderToPickList": "stockItems,customers",
  "pickList": "stockItems",
  "checkout-transactions-history": "stockItems",
  "checkin-transactions-history": "stockItems"
};
